export default __webpack_public_path__ + "static/media/duplicate@1x.a03bc17a.svg";